import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';

import { ChartType } from "chart.js";
import { ChartDataSets, ChartOptions } from "chart.js";
import { MultiDataSet, Label, Color, Colors, BaseChartDirective } from "ng2-charts";
import * as _moment from "moment";
import * as pluginDataLabels from "chartjs-plugin-datalabels";
import * as pluginAnnotations from "chartjs-plugin-annotation";
import Swal from 'sweetalert2';

import { Global } from 'src/app/globales/global';
import { NgxSpinnerService } from 'ngx-spinner';
import { TitleCasePipe } from '@angular/common';
import { PaymentsService } from 'src/app/services/payments.service';
import { PaymentsLineChartService } from '../services/chart/payments-line-chart.service';
import { PaymentsStoreService } from '../services/payments-store.service';
const moment = (_moment as any).default ? (_moment as any).default : _moment;


@Component({
  selector: 'app-payments-frequency-chart',
  templateUrl: './payments-frequency-chart.component.html',
  styleUrls: ['./payments-frequency-chart.component.scss'],
  providers: [TitleCasePipe, Global]
})
export class PaymentsFrequencyChartComponent implements OnInit {

  @ViewChild(BaseChartDirective) chart: BaseChartDirective;
  @Input() chartName: string = "";
  public lineChartData: ChartDataSets[] = [];

  public lineChartLabels: Label[] = [];
  public lineChartOptions: ChartOptions & { annotation: any };

  public lineChartColors: Color[] = [];
  public lineChartLegend = true;
  public lineChartType: ChartType = "line";
  public lineChartPlugins = [pluginAnnotations];


  public bankPaymentsByDay: any;
  public paymentsCountVsAmount: any;

  public dataBankPaymentsByDay: any = [];
  public labelsBankPaymentsByDay: any = [];

  constructor(
    private payments: PaymentsService,
    public titleCasePipe: TitleCasePipe,
    public spinner: NgxSpinnerService,
    public cdRef: ChangeDetectorRef,
    public global: Global,
    private lineChart: PaymentsLineChartService,
    private store: PaymentsStoreService
  ) {
    this.initializeChart();
  }

  ngOnInit(): void {
    this.getPaymentsCountVsAmount();
  }

  initializeChart() {
    this.lineChartColors = this.lineChart.lineChartColors;
    this.lineChartOptions = this.lineChart.lineChartOptions;
    this.lineChartData = this.lineChart.lineChartData;
    this.lineChartData[0].data = this.lineChart.lineChartData[0].data;
  }


  getPaymentsCountVsAmount() {
    this.payments.getPaymentsCountVsAmount().subscribe(
      (paymentsCountVsAmountResponse: any) => {
        // console.log('data -> ', paymentsCountVsAmountResponse);
        if (paymentsCountVsAmountResponse && paymentsCountVsAmountResponse.length < 1) {
          this.noDataModal();
          return;
        }
        this.paymentsCountVsAmount = paymentsCountVsAmountResponse;
        let amountChartData = [];
        let amountChartLabels = [];
        let countChartData = [];
        let countChartLabels = [];
        this.paymentsCountVsAmount.data.forEach(({ date, totalAmount, totalPays, stringDate }, idx: number) => {
          amountChartData = [...amountChartData, totalAmount];
          amountChartLabels = [...amountChartLabels, stringDate];
          countChartData = [...countChartData, totalPays];
        });
        this.store.setAmountChart(amountChartLabels, amountChartData);
        this.store.setCountChart(amountChartLabels, countChartData);
      }, (error: any) => {
        console.log('error -> ', error);
        this.paymentsCountVsAmount = [];
        this.store.setAmountChart([], []);
        this.store.setCountChart([], []);
        //this.noDataModal();
      });
  }

  noDataModal() {
    Swal.fire({
      type: "info",
      title: "No hay información disponible",
      text: "",
    });
  }

}
